import axios from 'axios'
import Qs from 'qs'
import { message } from 'ant-design-vue'

export function createService (options) {
// 创建axios实例
  const service = axios.create({
    baseURL: '/api',
    withCredentials: true,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'comma' }),
    headers: {
      'Content-Type': 'application/json', // application/x-www-form-urlencoded;charset=utf-8;
      'Access-Control-Allow-Origin': '*'
    },
    timeout: 15000 // 请求超时时间
  })

  const requestConfig = config => {
    const params = config.data ? config.data : {}
    if (params) {
      const _params = {}
      for (const [key, value] of Object.entries(params)) {
        const _url = config.url
        config.url = config.url.replace(new RegExp('\\{' + key + '\\}', 'g'), value)
        if (_url === config.url) {
          _params[key] = value
        }
      }
      config.data = _params
    }
    return config
  }

  const responseConfig = response => {
    const res = response.data
    const headers = response.headers
    if (res.code === 200) {
      return res.data || res.result
    } else if (res.code === 403) {
      // 未授权页面跳转
      window.location.href = '#'
      // window.location.href = '/403'
    } else if (headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8') {
      return res
    } else {
      message.error(res.message || '服务器异常')
      return Promise.reject(res.message)
    }
  }

  const errConfig = error => {
    if (error.response.status === 401) {
      location.href = `${process.env.VUE_APP_PASSPORT_URL}/api/op/auth/login?referrer=${encodeURIComponent(location.href)}`
    } else {
      message.error(error.response.data.message || '服务器异常')
    }
    return Promise.reject(error)
  }

  service.interceptors.request.use(
    options.request ? options.request : requestConfig
  )

  service.interceptors.response.use(
    options.response ? options.response : responseConfig, options.err ? options.err : errConfig
  )
  return service
}
